module.exports = __webpack_public_path__ + "img/samuel-weiss.a5fedcb.jpg";